import { render, staticRenderFns } from "./BeeDeleteDialog.vue?vue&type=template&id=3843273a&"
import script from "./BeeDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./BeeDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports